/**
 * RESPONSIBILITY: draw a block that is one box of words.
 *
 * The HTML was rendered when the block was saved (see @RenderOf), so nothing a client
 * sent reaches dangerouslySetInnerHTML.
 */
import { Html } from '@framework/react';
import { ADC_THEME } from '@app/sections';
import { AdcBand } from './AdcBand';
import type { AdcBlockProps } from './kind';

export function AdcText({ b }: AdcBlockProps) {
  if (!b.bodyHtml) return null;
  return (
    <AdcBand theme={ADC_THEME.Text} heading={b.heading}>
      <Html className="md-body adc-copy adc-copy-centre">{b.bodyHtml}</Html>
    </AdcBand>
  );
}
